// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qZBc9","index":"styles_index__X_xlv"};